import { graphql } from 'gql';

export const getWorkOrderVersionOtherPriceList = graphql(`
    query uerWorkOrderVersionOtherPriceList(
        $workOrderVersionId: Long!
        $workOrderVersionObjectId: Long!
        $skip: Int
        $take: Int
        $where: WorkOrderVersionOtherPriceDataFilterInput
    ) {
        uerWorkOrderVersionOtherPriceList(
            workOrderVersionId: $workOrderVersionId
            workOrderVersionObjectId: $workOrderVersionObjectId
            skip: $skip
            take: $take
            where: $where
        ) {
            items {
                id
                actKC2VersionPrices {
                    actKC2VersionStatus
                    actKC2VersionSeasonId
                    actKC2VersionId
                    acceptedCost
                    planCost
                    acceptedCostDeviation
                    planCostDeviation
                }
                calculatingType
                chapter
                contractOtherId
                hasEmptyActVersionAcceptedCost
                hasEmptyActVersionPlanCost
                hasEmptySeasonCost
                isActKC2VersionPrice
                isExcludedPrice
                name
                seasonPrices {
                    planCost
                    seasonId
                    remainderCost
                    completedCost
                }
                section
                status
                totalCompletedCost
                totalPlanCost
                totalRemainderCost
            }
        }
    }
`);
